import { useQuery } from "@apollo/client";
import { BaseTable, Flexbox, IBaseTableProps } from "@sede-x/shell-ds-react-framework";
import { ColumnDef, getPaginationRowModel } from "@tanstack/react-table";
import { loader } from "graphql.macro";
import { useState } from "react";
import { ApolloErrorViewer } from "shared/components/ApolloErrorViewer";
import LoadingPanel from "shared/components/LoadingPanel";
import { GqlResponse, TTicketMovementRevision } from "ticketing/ticketing.types";

type Response = GqlResponse<TTicketMovementRevision[], "movementsOfTicketAtRevision">;

const query = loader("../../ticketing-graphql/movementsOfTicketAtRevision.graphql");
/**
 * LastModifiedByCell
 * @param props
 * @returns
 */

type RevisionsTicketMovementsProps = {
  ticketId: string;
  revisionNumber: string;
};

/**
 *
 * @param param0
 * @returns
 */
const RevisionsTicketMovements = ({
  ticketId,
  revisionNumber
}: RevisionsTicketMovementsProps) => {
  const [revisions, setRevisions] = useState<TTicketMovementRevision[]>();

  const { loading, error } = useQuery<Response>(query, {
    fetchPolicy: "no-cache",
    variables: { ticketId, revisionNumber },
    onCompleted: data => setRevisions(transformData(data.movementsOfTicketAtRevision))
  });

  const transformData = (ticketRevisionMovements: TTicketMovementRevision[]) => {
    return ticketRevisionMovements?.map(trm => ({
      ...trm,
      lastModifiedDate: new Date(trm?.lastModifiedDate + "Z")
    }));
  };

  const columns: ColumnDef<TTicketMovementRevision, string>[] = [
    {
      header: "Movement Id",
      accessorKey: "enterpriseSystemCode",

      size: 150
    },
    {
      header: "Last Update Date",
      accessorKey: "lastModifiedDate",
      cell: props => props.row.original.lastModifiedDate.toLocaleString()
    },
    {
      header: "Updated By",
      accessorKey: "lastModifiedBy",
      cell: props =>
        [
          props.row.original.lastModifiedBy.lastName,
          props.row.original.lastModifiedBy.firstName
        ]
          .filter(Boolean)
          .join(", ")
    }
  ];

  const tableOptions: IBaseTableProps<TTicketMovementRevision>["tableOptions"] = {
    defaultColumn: {
      minSize: 100,
      maxSize: 400
    },
    getPaginationRowModel: getPaginationRowModel(),
    columnResizeMode: "onChange" ,
    enableColumnResizing: true
  };
  

  return (
    <Flexbox
      flexDirection="column"
      style={{
        overflow: "auto"
      }}>
      {loading && <LoadingPanel />}
      {error && <ApolloErrorViewer error={error} />}
      <BaseTable
        columns={columns}
        data={revisions}
        noFooter={true}
        tableOptions={tableOptions}
        style={{ width: "100%", tableLayout: "fixed" }}
      />
    </Flexbox>
  );
};

export default RevisionsTicketMovements;
